export const actionsType = [
  { value: -1, label: '全部' },
  { value: 1, label: '测试录取几率' },
  { value: 2, label: '测试题申请学校' },
  { value: 3, label: '沪江活动(礼券)' },
  { value: 4, label: '砸蛋中奖品' },
  { value: 5, label: '百度传课绑定' },
  { value: 6, label: '百度传课测试录取几率' },
  { value: 7, label: '确认择校规划单' },
  { value: 8, label: '竞力报告书' },
  { value: 9, label: '目标学校录取测试' },
  { value: 10, label: '闪注' }
];

// 学校类型
export const schoolType = [
  { value: 1, label: '985' },
  { value: 2, label: '211' },
  { value: 3, label: '双非' },
  { value: 4, label: '无' },
  { value: -1, label: '未填写学校' },
];

// 被转资源
export const transferredResources = [
  { value: 7, label: '被转资源' }
];

// 客户分级类型
export const customLvType = [
  { value: 50, label: '等待处理' },
  { value: 51, label: '联系中' },
  { value: 53, label: '有意向' },
  { value: 61, label: '犹豫中' },
  { value: 58, label: '放弃' },
  { value: 60, label: '转前程日本' },
  { value: 57, label: '已签约' },
  { value: 55, label: '长期跟进' },
  { value: 62, label: '在DIY' },
  { value: 63, label: '签它方' },
  { value: 64, label: '返上一级' },
  { value: 65, label: '已解约' },
  { value: 66, label: '最终放弃' },
];

// 申请方式
export const proposalType = [
  { value: 3, label: 'A&A' },
  { value: 1, label: '公司申请' },
  { value: 6, label: '中智' },
  { value: 4, label: 'ACIC' },
  { value: 2, label: '代理申请' },
  { value: 5, label: 'IDP' },
];

// 咨询方式
export const consultingType = [
  { value: 1, label: '电话' },
  { value: 2, label: 'QQ' },
  { value: 3, label: '微信' },
  { value: 4, label: '来店' },
  { value: 5, label: '其他' },
];

// 签约评级
export const signingLevelType = [
  { value: 1, label: '★☆☆☆☆' },
  { value: 2, label: '★★☆☆☆' },
  { value: 3, label: '★★★☆☆' },
  { value: 4, label: '★★★★☆' },
  { value: 5, label: '★★★★★' }
];

// 代言人计划
export const rugbyPeople = [
  { value: 1, label: '来自代言人推荐' }
];

// 客户签约类型
export const customLevelType = [
  { value: 7, label: '已签约' },
  { value: 9, label: '已解约' }
];

// 择校计划
export const chooseSchoolPlans = [
  { value: 1, label: '无' },
  { value: 2, label: '待提交' },
  { value: 3, label: '待学生确认' },
  { value: 4, label: '学生已确认' },
  { value: 99, label: '已做择校规划' },
  { value: -1, label: '已签约未做择校规划' },
];

// 性别
export const gender = [
  { value: 1, label: '男' },
  { value: 2, label: '女' },
  { value: 3, label: '未知' },
];

// 客户星级
export const crmStar = [
  { value: 1, label: '★' },
  { value: 2, label: '★★' },
  { value: 3, label: '★★★' },
  { value: 4, label: '★★★★' },
  { value: 5, label: '★★★★★' },
  { value: 6, label: '全部' },
];

// 专业
export const majorType = [
  { value: 1, label: '工学' },
  { value: 2, label: '理学' },
  { value: 3, label: '医学' },
  { value: 4, label: '农学' },
  { value: 5, label: '法学' },
  { value: 6, label: '管理学' },
  { value: 7, label: '教育学' },
  { value: 8, label: '经济学' },
  { value: 9, label: '历史学' },
  { value: 10, label: '文学' },
  { value: 11, label: '艺术学' },
  { value: 12, label: '哲学' },
  { value: 13, label: '军事学' },
  { value: 99, label: '其他' },
];

// 选校信息状态

export const chooseInfo = [
  { value: 1, label: '等待审核' },
  { value: 6, label: '需详细沟通' },
  { value: 2, label: '未通过审核' },
  { value: 3, label: '开始申请' },
  { value: 5, label: '取消申请' },
];

// 留学时刻表
export const schedule = [
  { value: 2, label: '完成' },
  { value: 1, label: '草稿' },
  { value: 0, label: '无' }
];

// 国家货币

export const countryMoney = [
  { value: 30, label: '英镑' },
  { value: 31, label: '澳元' },
  { value: 83, label: '日元' },
  { value: 471, label: '美元' },
  { value: 672, label: '韩元' },
  { value: 673, label: '纽币' },
  { value: 674, label: '欧元' },
  { value: 1770, label: '港元' },
  { value: 1831, label: '欧元' },
  { value: 1839, label: '澳门元' },
  { value: 1867, label: '瑞士法郎' },
  { value: 1869, label: '欧元' },
  { value: 1870, label: '欧元' },
  { value: 1871, label: '欧元' },
  { value: 1872, label: '欧元' },
  { value: 1874, label: '布朗' },
  { value: 1875, label: '布朗' },
  { value: 1876, label: '克朗' },
  { value: 1877, label: '欧元' },
  { value: 1878, label: '欧元' },
  { value: 1879, label: '卢布' },
  { value: 1881, label: '欧元' },
  { value: 675, label: '新加坡元' },
  { value: 486, label: '加元' },
];


// 国家

export const shCountry = [
  { value: 30, label: 1 },
  { value: 31, label: 2 },
  { value: 83, label: 238 },
  { value: 471, label: 471 },
  { value: 672, label: 2047 },
  { value: 673, label: 2227 },
  { value: 674, label: 2228 },
  { value: 1770, label: 2229 },
  { value: 675, label: 2230 },
  { value: 486, label: 1287 },
];


// 申请结果

export const resShenqing = [
  { value: -1, label: '全部' },
  { value: 0, label: '申请中' },
  { value: 1, label: '申请成功' },
  { value: 2, label: '申请失败' }
];

// 创建方式

export const isCopy = [
  { value: 0, label: '手写' },
  { value: 1, label: '复制' }
];

// 案例综合分析

export const customPurpose = [
  { value: 1, label: '无' },
  { value: 2, label: '有' }
];

// 已做OFFER图片

export const isOfferImg = [
  { value: 1, label: '未做' },
  { value: 2, label: '已做' }
];

// GPA算法

export const gpaType = [
  { value: 1, label: '算数平均分' },
  { value: 2, label: '加权平均分' },
  { value: 3, label: '绩点' }
];

// offer是否推荐

export const isRecommend = [
  { value: 1, label: '已推荐' },
  { value: 2, label: '未推荐' }
];

// 评分

export const score = [
  { value: 1, label: '1分' },
  { value: 2, label: '2分' },
  { value: 3, label: '3分' },
  { value: 4, label: '4分' },
  { value: 5, label: '5分' }
];

// 是否

export const isTover = [
  { value: 1, label: '是' },
  { value: 2, label: '否' }
];

// 是否

export const isOver = [
  { value: 2, label: '是' },
  { value: 1, label: '否' }
];

// 申请流程状态

export const isOver2 = [
  { value: 2, label: '终止流程' },
  { value: 3, label: '入学' },
  { value: 1, label: '申请中' }
];

// 英国申请材料

export const ukShenqingCailiao = [
  { value: 0, label: '未开始' },
  { value: 535, label: '开始提交' },
  { value: 537, label: '补充材料' },
  { value: 539, label: '全部上交' },
];

// 英国递交校方

export const submitSchool = [
  { value: 0, label: '未开始' },
  { value: 1, label: '已递交' }
];

// 英国语言时长

export const langeWeek = [
  { value: 0, label: '无' },
  { value: 2, label: '2周' },
  { value: 3, label: '3周' },
  { value: 4, label: '4周' },
  { value: 5, label: '5周' },
  { value: 6, label: '6周' },
  { value: 7, label: '7周' },
  { value: 8, label: '8周' },
  { value: 9, label: '9周' },
  { value: 10, label: '10周' },
  { value: 11, label: '11周' },
  { value: 12, label: '12周' },
  { value: 13, label: '13周' },
  { value: 14, label: '14周' },
  { value: 15, label: '15周' },
  { value: 16, label: '16周' },
  { value: 17, label: '17周' },
  { value: 18, label: '18周' },
  { value: 19, label: '19周' },
  { value: 20, label: '20周' }
];

// aus延期Offer

export const ausOfferXiafa = [
  { value: 1, label: '无需延期' },
  { value: 2, label: '延期成功' },
  { value: 3, label: '延期失败' },
];

// aus申请结果

export const offerXiafaSwitch = [
  { value: 1, label: '获得语言Offer' },
  { value: 2, label: '未能成功获得语言Offer' }
];

// aus申请结果

export const langeOfferAccept = [
  { value: 1, label: '学生已接受' },
  { value: 2, label: '学生已拒绝' }
];

// aus申请结果

export const langePaySellTtype = [
  { value: 1, label: '电汇' },
  { value: 2, label: 'Online' }
];

// aus申请结果

export const langeCoe = [
  { value: 1, label: '成功获得语言COE' },
  { value: 2, label: '申请取消语言COE' }
];

// 正课支付方式

export const mainSubjectMoneyPay = [
  { value: 1, label: 'Online' },
  { value: 2, label: '电汇' },
  { value: 3, label: '汇票' }
];

// hasdijiao
export const hasdijiao = [
  { value: 1, label: '已递交' },
];

// 有无

export const hasno = [
  { value: 1, label: '无' },
  { value: 2, label: '有' }
];

// offer接受状态

export const getOffer = [
  { value: 1, label: '未接受' },
  { value: 2, label: '已经接受' }
];

// 现有雅思成绩

export const ieltsAll = [
  { value: 0, label: '无' },
  { value: 4, label: '4' },
  { value: 4.5, label: '4.5' },
  { value: 5, label: '5' },
  { value: 5.5, label: '5.5' },
  { value: 6, label: '6' },
  { value: 6.5, label: '6.5' },
  { value: 7, label: '7' },
  { value: 7.5, label: '7.5' },
  { value: 8, label: '8' },
  { value: 8.5, label: '8.5' },
  { value: 9, label: '9' }
];

// 身份类别

export const identity = [
  { value: 1, label: '学生' },
  { value: 2, label: '家长' },
];

// 口碑下拉
export const isKoubei = [
  { value: 2, label: '启用' },
  { value: 1, label: '未启用' },
  { value: 0, label: '无' }
];

// 口碑下拉
export const maixcoe = [
  { value: 1, label: '等待' },
  { value: 2, label: '已成功获得COE' },
  { value: 3, label: '申请取消正课COE' }
];

// 性别两个选项
export const genderTwo = [
  { value: 1, label: '男' },
  { value: 2, label: '女' },
];

// 状态
export const actStatus = [
  { value: 1, label: '有效' },
  { value: 2, label: '无效' },
];

// 关联创建人
export const linkCreater = [
  { value: 1, label: '活动创建人' },
  { value: 2, label: '非活动创建人' },
];

// 考培分级

export const examinationOfCulture = [
  { value: 1, label: '待处理' },
  { value: 2, label: '联系中' },
  { value: 3, label: '长期跟进' },
  { value: 4, label: '犹豫中' },
  { value: 5, label: '有意向' },
  { value: 6, label: '放弃' },
  { value: 7, label: '已签约' },
  { value: 8, label: '已解约' },
];

export const dealStatus = [
  { value: 0, label: '未处理' },
  { value: 1, label: '已处理' }
];

export const leadType = [
  { value: 1, label: '线索' },
  { value: 2, label: '新资源' },
  { value: 3, label: '老资源' }
];

// 回访类型
export const visitType = [
  { value: 1, label: '联系型' },
  { value: 2, label: '跟进型' },
  { value: 3, label: '运营型' },
];

// 报名表相关字段============
export const hasPassport = [
  { value: 0, label: '没有' },
  { value: 1, label: '有' },
  { value: 2, label: '申请中' },
];

export const japaneseMajor = [
  { value: 1, label: '是' },
  { value: 0, label: '否' },
];

export const artExam = [
  { value: 1, label: '是' },
  { value: 0, label: '否' },
];

export const parentLeave = [
  { value: 2, label: '否' },
  { value: 1, label: '是' },
];

export const interviewSex = [
  { value: 1, label: '男' },
  { value: 2, label: '女' },
];

export const married = [
  { value: 0, label: '未婚' },
  { value: 1, label: '已婚' },
  { value: 2, label: '离异' },
];

export const finalEdu = [
  { value: 1887, label: '硕士' },
  { value: 1888, label: '本科' },
  { value: 1889, label: '大专' },
  { value: 1890, label: '高中' },
  { value: 1891, label: '中专' },
  { value: 1892, label: '职高' },
  { value: 2047, label: '非全日制本科（含成教、自考、函授等)' },
  { value: 2048, label: '非全日制大专（含成教、自考、函授等)' },
  { value: 2049, label: '非全日制中专（含成教、自考、函授等)' },
  { value: 1901, label: '其他' },
];

export const examSubject = [
  { value: 1, label: '文科' },
  { value: 2, label: '理科' },
];

export const generalStatus = [
  { value: 0, label: '计划报名' },
  { value: 1, label: '已报名' },
  { value: 2, label: '已合格' },
  { value: 3, label: '未合格' },
];

export const examStatus = [
  { value: 0, label: '未参加' },
  { value: 1, label: '已参加' },
];

export const isDeny = [
  { value: 1, label: '是' },
  { value: 0, label: '否' },
];

export const isLive = [
  { value: 1, label: '是' },
  { value: 0, label: '否' },
];

// 是否建联成功
export const isHand = [
  { value: 1, label: '是' },
  { value: 0, label: '否' },
];
// 运营情况
export const opStatus = [
  { value: 1, label: '有意向' },
  { value: 2, label: '需内推' },
  { value: 3, label: '运营中' },
  { value: 4, label: '添加中' },
];

export const studentLevel = [
  { value: 9, label: 'D' },
  { value: 8, label: 'C' },
  { value: 7, label: 'B' },
  { value: 6, label: 'A' },
  { value: 5, label: '★★★★★' },
  { value: 3, label: '★★★' },
  { value: 1, label: '★' },
];

// 介绍资源
export const introducerStatus = [
  { value: 1, label: '是' },
  { value: 0, label: '否' },
];

// 线索分级
export const cluesLevel = [
  { value: 1, label: 'A' },
  { value: 2, label: 'B' },
  { value: 3, label: 'C' },
  { value: 4, label: 'D' },
  { value: 5, label: '其他' },
];
